module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home row"
  }, [_c('div', {
    staticClass: "col-12 px-0 d-flex flex-column flex-sm-row"
  }, [_c('div', {
    staticClass: "bg-inverse px-0 py-5"
  }, [_c('ul', {
    staticClass: "nav flex-column"
  }, [_c('li', {
    staticClass: "nav-item hidden-sm-up"
  }, [_c('a', {
    staticClass: "nav-link d-flex justify-content-center",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.toggleMenu
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("menu")])])]), _vm._v(" "), _c('div', {
    staticClass: "mt-5 mt-sm-0",
    class: {
      'hidden-xs-down': !_vm.isMenuOpened
    }
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    staticClass: "nav-link d-flex justify-content-center",
    attrs: {
      "to": "/",
      "exact": "",
      "title": "Mendelable"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("home")])])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item mt-5"
  }, [_c('router-link', {
    staticClass: "nav-link d-flex justify-content-center",
    attrs: {
      "to": "/game",
      "exact": "",
      "title": _vm.$t('home.gameMode')
    }
  }, [_c('i', {
    staticClass: "material-icons md-36",
    on: {
      "click": function($event) {
        _vm.trackClick('game', 'inbound')
      }
    }
  }, [_vm._v("games")])])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item mt-5"
  }, [_c('router-link', {
    staticClass: "nav-link d-flex justify-content-center",
    attrs: {
      "to": "/about",
      "exact": "",
      "title": _vm.$t('home.about')
    }
  }, [_c('i', {
    staticClass: "material-icons",
    on: {
      "click": function($event) {
        _vm.trackClick('help', 'inbound')
      }
    }
  }, [_vm._v("help_outline")])])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "container-fluid p-0 w-100 d-flex align-items-stretch"
  }, [_c('div', {
    staticClass: "row no-gutters w-100"
  }, [_c('div', {
    staticClass: "col-md-8 col-lg-9 col-xl-10 p-5"
  }, [(_vm.$route.name === 'PeriodicTable') ? _c('div', {
    staticClass: "d-flex justify-content-between"
  }, [_c('form', [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "searchInput",
      "placeholder": _vm.$t('general.search')
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('router-view')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-lg-3 col-xl-2 bg-faded px-4 py-5"
  }, [_c('a', {
    staticClass: "btn btn-outline-info btn-block mb-5",
    attrs: {
      "href": _vm.githubLink,
      "target": "_blank",
      "rel": "noopener"
    },
    on: {
      "click": function($event) {
        _vm.trackClick(_vm.githubLink, 'outbound')
      }
    }
  }, [_vm._v("Fork me on GitHub")]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t("sidebar.title")))]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.$t("language.label")))]), _vm._v(" "), _c('language-switcher'), _vm._v(" "), (_vm.$route.name !== 'About') ? _c('p', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.$t("sidebar.subtitle")))]) : _vm._e(), _vm._v(" "), _c('router-view', {
    attrs: {
      "name": "sidebar"
    }
  })], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-75601ffb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 646
// module chunks = 1